// Utility to clear all CV drafts from localStorage
export const clearAllCVDraftsFromLocalStorage = () => {
  try {
    // Remove CV drafts from localStorage
    localStorage.removeItem('recruitment_crm_cv_drafts');
    localStorage.removeItem('recruitment_crm_current_cv_draft');
    
    // Remove any other CV draft related items
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.includes('cv_draft') || key.includes('cvDraft') || key.includes('cv-draft'))) {
        keysToRemove.push(key);
      }
    }
    
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
    
    console.log('✅ Cleared all CV drafts from localStorage');
    return true;
  } catch (error) {
    console.error('❌ Failed to clear CV drafts:', error);
    return false;
  }
};